import { CARRIER_METHOD } from "features/Cart/constants";
import { useGetShippingProviderLazy } from "hooks/cart";

const isInstant = (provider) => provider?.carrierMethods?.includes(CARRIER_METHOD.INSTANT);

/**
 * Cả 2 dropdown ĐVVC ("Chuyển phát"/"Giao hàng hoả tốc") dùng chung 1 API `shippingProvider.list`,
 * lọc theo `carrierMethods` — giống popup đổi PTVC. KHÔNG dùng `getCartServiceFee`: BE trả
 * PermissionDenied cho tài khoản vận hành nên phí luôn về `null`. Chỉ gọi khi user mở dropdown.
 */
const useAdditionalDeliver = () => {
  const { fetchShippingProvider, data: dataShippingProvider } = useGetShippingProviderLazy();

  const buildProviderOptions = (providers) =>
    providers?.map((provider) => ({ value: provider?.id, label: provider?.name, fee: provider?.fee }));

  const shippingProviderOptions = buildProviderOptions(
    dataShippingProvider?.filter((provider) => !isInstant(provider))
  );
  const instantProviderOptions = buildProviderOptions(dataShippingProvider?.filter(isInstant));

  return {
    shippingProviderOptions,
    instantProviderOptions,
    fetchShippingProviderOptions: fetchShippingProvider,
  };
};

export default useAdditionalDeliver;
